import { Components, Theme } from '@mui/material'
import { palette } from '../palette'

declare module '@mui/material/Alert' {
  interface AlertPropsVariantOverrides {
    muted: true
    filled: false
  }
}

export const MuiAlert: Components<Omit<Theme, 'components'>>['MuiAlert'] = {
  styleOverrides: {
    action: {
      alignItems: 'center',
      padding: '0 0 0 16px',
    },
    root: {
      // We use variant=outlined, but remove the border here
      border: 'none',
      '& pre': {
        color: palette.neutralDark.main,
        padding: '10px 16px',
        backgroundColor: '#00000010',
        borderRadius: 4,
        margin: 0,
        marginTop: 4,
        whiteSpace: 'pre-wrap',
      },
    },
  },
  variants: [
    {
      props: { severity: 'info' },
      style: {
        backgroundColor: palette.purple[100],
        color: palette.purple[700],
        '& .MuiAlert-icon': {
          color: palette.purple[700],
        },
        '& .MuiAlert-action .MuiButton-root, & .MuiAlert-action .MuiButtonBase-root': {
          color: palette.purple[700],
        },
      },
    },
    {
      props: { severity: 'warning' },
      style: {
        backgroundColor: palette.amber[100],
        color: palette.amber[900],
        '& .MuiAlert-icon': {
          color: palette.amber[900],
        },
        '& .MuiAlert-action .MuiButton-root, & .MuiAlert-action .MuiButtonBase-root': {
          color: palette.amber[900],
        },
      },
    },
    {
      props: { severity: 'success' },
      style: {
        backgroundColor: palette.green[100],
        color: palette.green[900],
        '& .MuiAlert-icon': {
          color: palette.green[900],
        },
        '& .MuiAlert-action .MuiButton-root, & .MuiAlert-action .MuiButtonBase-root': {
          color: palette.green[900],
        },
      },
    },
    {
      props: { severity: 'error' },
      style: {
        backgroundColor: palette.red[100],
        color: palette.red[900],
        '& .MuiAlert-icon': {
          color: palette.red[900],
        },
        '& .MuiAlert-action .MuiButton-root, & .MuiAlert-action .MuiButtonBase-root': {
          color: palette.red[900],
        },
      },
    },
    {
      props: { variant: 'muted' },
      style: {
        border: '1px solid',
        color: palette.neutralDark.main,
      },
    },
    {
      props: { variant: 'muted', severity: 'warning' },
      style: {
        backgroundColor: palette.warning.light,
        borderColor: palette.amber[100],
        '& .MuiAlert-icon': {
          color: palette.amber[900],
        },
        '& .MuiAlert-action .MuiButton-root, & .MuiAlert-action .MuiButtonBase-root': {
          color: palette.amber[900],
        },
      },
    },
    {
      props: { variant: 'muted', severity: 'info' },
      style: {
        backgroundColor: palette.purple[50],
        borderColor: palette.purple[100],
        '& .MuiAlert-icon': {
          color: palette.purple[500],
        },
        '& .MuiAlert-action .MuiButton-root, & .MuiAlert-action .MuiButtonBase-root': {
          color: palette.purple[500],
        },
      },
    },
    {
      props: { variant: 'muted', severity: 'success' },
      style: {
        backgroundColor: palette.green[50],
        borderColor: palette.green[100],
        '& .MuiAlert-icon': {
          color: palette.green[700],
        },
        '& .MuiAlert-action .MuiButton-root, & .MuiAlert-action .MuiButtonBase-root': {
          color: palette.green[700],
        },
      },
    },
    {
      props: { variant: 'muted', severity: 'error' },
      style: {
        backgroundColor: palette.red[50],
        borderColor: palette.red[100],
        '& .MuiAlert-icon': {
          color: palette.red[700],
        },
        '& .MuiAlert-action .MuiButton-root, & .MuiAlert-action .MuiButtonBase-root': {
          color: palette.red[700],
        },
      },
    },
  ],
}
